function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1d1b;}.cls-2{fill:#00a19a;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M125.3,54.28H110.24l-3.6,9.5h-5l13.53-34h5.42l13.53,34H129Zm-13.38-4.37h11.7l-5.9-15.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M150.85,45.26a13.44,13.44,0,0,0-2-.15c-3.8,0-6.34,2-6.34,7.1V63.78H138V40.7h4.41v4a7.24,7.24,0,0,1,6.91-4.42,8.13,8.13,0,0,1,1.49.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M162.42,40.7h5v4.07h-5v12c0,2.11.86,3.17,3.22,3.17a9.59,9.59,0,0,0,1.77-.19v3.84a10,10,0,0,1-3.07.43c-3.93,0-6.43-2.4-6.43-6.58V44.77H153.5V40.7h1.24a3.23,3.23,0,0,0,3.55-3.55V33.4h4.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M174.24,28.7A3.24,3.24,0,1,1,171,32,3.24,3.24,0,0,1,174.24,28.7ZM172,63.78V40.7h4.47V63.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M185.34,56.34c.29,2.4,2.11,4.32,5.38,4.32,2.54,0,3.93-1.44,3.93-3.07,0-1.44-1.05-2.55-3-3l-3.94-.86c-3.6-.77-5.76-3.22-5.76-6.48,0-3.93,3.7-7.29,8.21-7.29,6.33,0,8.3,4.12,8.78,6.19l-4,1.48a4.47,4.47,0,0,0-4.8-3.83c-2.3,0-3.84,1.48-3.84,3.07,0,1.39.86,2.4,2.64,2.78l3.74.82c4.18.91,6.38,3.45,6.38,6.86,0,3.26-2.73,7.15-8.44,7.15-6.33,0-9-4.08-9.41-6.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M211.14,40.7h5v4.07h-5v12c0,2.11.86,3.17,3.22,3.17a9.59,9.59,0,0,0,1.77-.19v3.84a10,10,0,0,1-3.07.43c-3.94,0-6.43-2.4-6.43-6.58V44.77h-4.42V40.7h1.25A3.23,3.23,0,0,0,207,37.15V33.4h4.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M252.08,39a6.91,6.91,0,0,0-7.2-5.81c-3.84,0-6.57,2.5-6.57,5.67,0,2.44,1.48,4.31,4.36,4.94l5.09,1.1c5.66,1.25,8.83,4.8,8.83,9.55,0,5.28-4.51,10.08-11.76,10.08-8.2,0-12.09-5.28-12.72-10.13l4.52-1.44a7.73,7.73,0,0,0,8.15,7.3c4.71,0,7-2.45,7-5.43,0-2.44-1.68-4.55-5.09-5.27l-4.84-1.06c-4.85-1.06-8.31-4.22-8.31-9.31,0-5.33,4.95-10.12,11.23-10.12,7.68,0,10.75,4.75,11.52,8.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M282.43,57.2a10.47,10.47,0,0,1-10.37,7.3c-6.19,0-11.61-4.51-11.61-12.33,0-7.25,5.23-12.19,11-12.19,7.1,0,11.08,4.89,11.08,12.09a10.1,10.1,0,0,1-.09,1.44H265.1a6.85,6.85,0,0,0,7,7,6.28,6.28,0,0,0,6.48-4.65Zm-4.56-7.34c-.1-3.31-2.25-5.9-6.33-5.9a6.21,6.21,0,0,0-6.29,5.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M300.63,45.26a13.47,13.47,0,0,0-2-.15c-3.79,0-6.33,2-6.33,7.1V63.78h-4.51V40.7h4.41v4a7.24,7.24,0,0,1,6.91-4.42,8.13,8.13,0,0,1,1.49.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M317,63.78h-4.56L303,40.7h5.08l6.58,17.8,6.62-17.8h4.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M349.44,57.2a10.47,10.47,0,0,1-10.37,7.3c-6.19,0-11.61-4.51-11.61-12.33,0-7.25,5.23-12.19,11-12.19,7.1,0,11.08,4.89,11.08,12.09a10.1,10.1,0,0,1-.09,1.44H332.12a6.84,6.84,0,0,0,6.95,7,6.28,6.28,0,0,0,6.48-4.65Zm-4.56-7.34c-.1-3.31-2.25-5.9-6.33-5.9a6.21,6.21,0,0,0-6.29,5.9Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "48.57 79.24 0 79.24 7.87 66.58 22.99 66.74 22.99 66.74 41.27 66.74 24.18 38.95 47.09 0 94.98 79.46 80.3 79.24 47.02 24.78 38.76 38.81 55.9 66.67 48.57 79.24"
})));

const SvgLogoWithText = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 349.58 79.46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoWithText, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-with-text.4251b1f6.svg";
export { ForwardRef as ReactComponent };